import { faRotateLeft } from '@fortawesome/pro-light-svg-icons'
import { PaymentMethodModelType } from '@teinor/erp/types/company/config/paymentMethod'
import { ComponentWithPermissions } from '../../../../../baseComponents/CreateRoutering/types'
import { permissionCheck } from '../../../../../baseComponents/PermissionChecker/function'
import TwinTable from '../../../../../baseComponents/TwinTable'
import BaseScreenTable from '../../../../../baseComponents/TwinTable/BaseScreenTable'
import { TableComponentProps } from '../../../../../baseComponents/TwinTable/BaseScreenTable/types'
import { CustomRenderBoolean, DeleteRow, EditRow } from '../../../../../baseComponents/TwinTable/VirtualTableListing/CustomRenders'
import { ColumnTableSchema } from '../../../../../baseComponents/TwinTable/VirtualTableListing/Subcomponents/types'
import useTwinTranslation from '../../../../../utils/hooks/useTwinTranslation'
import ModalCEPaymentMethod from './ModalCEPaymentMethod'
import ModalDeletePaymentMethod from './ModalDeletePaymentMethod'

interface ConfigPaymentMethodsProps extends ComponentWithPermissions { }

const ConfigPaymentMethods: React.FC<ConfigPaymentMethodsProps> = ({ userPermissions }) => {
    const { t } = useTwinTranslation()

    const pageData = {
        title: t('paymentMethods', 'Métodos de pago'),
        newText: t('newPaymentMethod', 'Nuevo método de pago'),
    }

    return (
        <BaseScreenTable TableComponent={TablePaymentMethods} CreateModalComponent={ModalCEPaymentMethod} EditModalComponent={ModalCEPaymentMethod} DeleteModalComponent={ModalDeletePaymentMethod} pageData={pageData} userPermissions={userPermissions} />
    )
}

interface TablePaymentMethodsProps extends TableComponentProps { }

const TablePaymentMethods: React.FC<TablePaymentMethodsProps> = ({ setTableInstance, userPermissions, setOpened }) => {
    const { t } = useTwinTranslation()

    const columns: ColumnTableSchema<PaymentMethodModelType> = [
        {
            id: 'id',
            dataKey: 'id',
            width: 200,
            label: t('id', 'ID'),
            sortable: true,
            searchableComponent: {
                component: 'SearchableComponentBasic',
                extraComponentData: { label: t('id', 'ID') }
            }
        },
        {
            id: 'name',
            dataKey: 'name',
            label: t('name', 'Nombre'),
            sortable: true,
            searchableComponent: {
                component: 'SearchableComponentBasic',
                extraComponentData: { label: t('id', 'ID') }
            }
        },
        {
            id: 'active',
            dataKey: 'active',
            label: t('active', 'Activo'),
            customRender: (parameterValue) => <CustomRenderBoolean value={String(parameterValue) === 'true'} width={45} />,
            generalSearchable: false
        },
        {
            id: 'edit',
            dataKey: 'id',
            label: '',
            width: 50,
            customRender: (parameterValue, allRowData) => <EditRow key={'edit' + parameterValue} {...{ parameterValue, allRowData }} onClick={(_idk, allRowData) => setOpened({ type: 'edit', allRowData })} />,
            havePermission: permissionCheck(userPermissions, 'update')
        },
        {
            id: 'delete',
            dataKey: 'id',
            label: '',
            width: 50,
            simpleLabel: t('delete', 'Eliminar'),
            customRender: (parameterValue, allRowData) => {
                const icon = !allRowData?.active ? faRotateLeft : undefined
                return <DeleteRow key={'delete' + parameterValue} {...{ icon, parameterValue, allRowData }} onClick={(_idk, allRowData) => setOpened({ type: 'delete', allRowData })} />
            },
            havePermission: permissionCheck(userPermissions, 'delete')
        }
    ]
    return (
        <TwinTable name='paymentMethods' columns={columns} getDataFrom='/api/app/config/payment/paymentMethod/getAllPaymentMethods' setTableInstance={setTableInstance} onRowClick={(_idk, allRowData) => setOpened({ type: 'edit', allRowData })} />
    )
}

export default ConfigPaymentMethods